<!-- <div class="group4">
  <h4 style="margin-top: 0;" *ngIf="!hidetitle"> Liste des documents </h4>
</div> -->

<div class="group4  detail" *ngIf="!isEmpty" style="height: 100%; padding: 0px;margin: 0 -15px;
width: calc(100% + 30px);"
  (click)="common.outSide($event)">
  <div class="header col-sm-12">
      <div class="col-sm-6">
        <button class="btn-add" id="addLigne" (click)="addLigne()">
          <i class="fa fa-plus"></i>
        </button>
        <span (click)="addLigne()">Ajouter une ligne</span>
      </div>
      <div class="col-sm-6 text-right">
        <h3 style="    margin: 5px 0; font-size: 21px;"> Liste des documents </h3>
      </div>
    </div>
    <div class="col-sm-12 ligneBon liste">
      <ngx-datatable style="height: 100%" class="material document" [rows]="chantier.listDoc || []"
        [columnMode]="'force'" [headerHeight]="30" [footerHeight]="0" [rowHeight]="40"
        [selectionType]="'checkbox'" [messages]="{emptyMessage: 'Pas de lignes à afficher'}"
        [loadingIndicator]="loadingIndicator" (activate)="onActivate($event)">
        <ngx-datatable-column name="Description">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
            let-selectFn="selectFn" let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Description </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <div *ngIf="row.id">
              {{value}}
            </div>
            <div *ngIf="!row.id">
              <input type="text" class="form-control" [(ngModel)]="row.description">
            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column prop="description">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
            let-selectFn="selectFn" let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Fichier </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <div *ngIf="row.id">
              {{value}}
            </div>
            <div *ngIf="!row.id">
              <input class="hide" id="input-file-id{{rowIndex}}" (change)="getNameFile($event, row)"
                type="file" accept=".pdf"/>
              <div class="input-group">
                <input type="text" class="form-control" [(ngModel)]="row.nomFichierOriginal" readonly>
                <label class="input-group-addon" for="input-file-id{{rowIndex}}"><i class="fa fa-upload"></i>
                  Parcourir </label>
              </div>
            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column *ngIf="!common.isHisto" [width]="70" [sortable]="false" [canAutoResize]="false"
          [draggable]="false" [resizeable]="false">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
            <button class="btn-detail" (click)="deleteLigne(row)">
              <i class="fa fa-trash"></i>
            </button>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>

</div>

<app-empty-detail-fact *ngIf="isEmpty" id="empty"></app-empty-detail-fact>

<ng-template #msg>
    <div class="modal-body" style="height: auto">
      <div>
        <div class="col-sm-12">
          <label class="cofirmemsg"> {{ error }} </label>
        </div>
      </div>
      <div class="text-right" style="margin-top: 15px;">
        <button type="button" class=" btn-close btn-validerMdl" (click)="error = ''; common.closeModal()"> Fermer
        </button>
      </div>
    </div>
  </ng-template>